/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AdditionalInsuredResponseDto = {
    /**
     * Unique identifier for the additional insured
     */
    id: string;
    /**
     * Title (MR, MRS, MS, DOCTOR, etc. — uppercase Ando values)
     */
    title?: string | null;
    /**
     * First name
     */
    firstName: string;
    /**
     * Last name
     */
    lastName: string;
    /**
     * Date of birth
     */
    dob: string;
    /**
     * Gender
     */
    gender: AdditionalInsuredResponseDto.gender;
    /**
     * Preferred name
     */
    preferredName?: string | null;
    /**
     * Email address
     */
    email?: string | null;
    /**
     * Preferred phone type
     */
    preferredPhone?: AdditionalInsuredResponseDto.preferredPhone | null;
    /**
     * Mobile phone number
     */
    mobile?: string | null;
    /**
     * Home phone number
     */
    homePhone?: string | null;
    /**
     * Work phone number
     */
    workPhone?: string | null;
    /**
     * Relationship to the client
     */
    relationship?: AdditionalInsuredResponseDto.relationship | null;
    /**
     * Creation timestamp
     */
    createdAt: string;
    /**
     * Last update timestamp
     */
    updatedAt: string;
};
export namespace AdditionalInsuredResponseDto {
    /**
     * Gender
     */
    export enum gender {
        MALE = 'MALE',
        FEMALE = 'FEMALE',
        OTHER = 'OTHER',
    }
    /**
     * Preferred phone type
     */
    export enum preferredPhone {
        MOBILE = 'MOBILE',
        HOME = 'HOME',
        WORK = 'WORK',
    }
    /**
     * Relationship to the client
     */
    export enum relationship {
        PARTNER_SPOUSE = 'PARTNER_SPOUSE',
        PARENT = 'PARENT',
        CHILD = 'CHILD',
        FRIEND = 'FRIEND',
        OTHER = 'OTHER',
        POLICY_OWNER = 'POLICY_OWNER',
        BUSINESS_PARTNER = 'BUSINESS_PARTNER',
        SIBLING = 'SIBLING',
    }
}

